import {cssClass, ICustomButton} from "lib-base";

export interface OptionCarousel {
  title: string;
  description: string;
  images: ImageCarousel[] | ImageCarousel;
  link?: string;
  button?: ICustomButton
}

export interface ImageCarousel extends Iimage {
  media?: string;
  sizes?: string;
  default?: boolean;
}

export interface Iimage {
  src: string;
  alt: string;
  class?: cssClass;
  ngStyle?: { [p: string]: any } | null;
}

export interface CardNoticias {
  img?: Iimage;
  title: string;
  pubDate: Date;
  link: string;
  guid: string;
  author: string;
  thumbnail?: string;
  description: string;
  content: string;
  categories: string[] | string;
}

export interface CardPQRSDF {
  img: Iimage,
  titleHtml?:string;
  description: string;
  link?: string;
  command?: any;
}


export class StateRequest {
  complete:boolean = false;
  loading:boolean = false;
  error:boolean = false;
}
